'use strict';

angular.module('theme').component('orderGiftcard', {
	templateUrl: 'component/order-giftcard.html',
	bindings: {
		public: '<',
	},
	controller: function (CustomerService, GiftcardService, Toast) {
		var self = this;

		self.$onInit = function () {
			self.existingEmail = false;
			
			if (!self.public) {
				CustomerService.get().then(function (customer) {
					self.formData.email = customer.email;
					self.formData.customerId = customer.id;
				});
			}

			self.formData = GiftcardService.getCart() || {};

			if (self.formData && self.formData.value) {
				self.standardValue = self.formData.value == 500 || self.formData.value == 1000 || self.formData.value == 1500;
				if (!self.standardValue) {
					self.showCustomValueBtn = true;
					self.customValue = self.formData.value;
				}
			} else {
				self.formData.checkoutType = 'customer';
			}
		};

		self.setValue = function(value) {
			self.standardValue = true;
			self.customValue = undefined;
			self.showCustomValueBtn = false;
			self.formData.value = value;
		};

		self.setCustomValue = function() {
			self.standardValue = false;
			self.formData.value = self.customValue;
		};

		self.toggleCustomValueBtn = function() {
			if (self.customValue && self.customValue >= 400) {
				self.showCustomValueBtn = true;
			}
		};

		self.order = function() {
			if (self.processing) return;

			self.processing = true;
			self.error = false;

			// If public order we create customer and send them to klarna checkout
			if (self.public) {
				self.createCustomer();
				return;
			}

			GiftcardService.setCart(self.formData);

			GiftcardService.getSummary(self.formData).then(function() {
				GiftcardService.order(self.formData).then(function() {
					Toast.successContent('<i class="mk-icon mk-icon-share mk-icon-x5"></i><h2 class="mt-md">Tack för din beställning!</h2><p class="lead">Ett mail med orderbekräftelse och presentkortskoder är snart på väg</p>', '/mypage/', 5000);
				}, function() {
					self.error = true;
					self.processing = false;
				});
			}, function() {
				self.error = true;
				self.processing = false;
			});
		};

		self.createCustomer = function() {
			if (self.formData.checkoutType === 'customer') {		
				CustomerService.createCustomer(self.formData.email).then(function(customer) {
					self.formData.customerId = customer.id;
					GiftcardService.setCart(self.formData);

					location.href = '/giftcard/checkout';
				}, function(errorResponse) {

					if (errorResponse.data && errorResponse.data.status && errorResponse.data.status == 201) {
						self.existingEmail = true;
					} else {
						self.error = true;
					}

					self.processing = false;
		
				});
			} else {
				CustomerService.createTempCustomer(self.formData.email).then(function(customer) {
					self.formData.customerId = customer.id;
					GiftcardService.setCart(self.formData);
					location.href = '/giftcard/checkout';
				}, function() {
					self.error = true;
					self.processing = false;
				});
			}
		};

		self.useSimpleCheckout = function() {
			self.formData.checkoutType = 'simple';
			self.order();
		};
	},
});
